import React from "react";
import Navbar from "../components/Navbar";
import Giraffe from "../components/Giraffe";
import Footer from "../components/Footer";

function GiraffeProject() {
  return (
    <>
      <Navbar />
      <Giraffe />
      <Footer />
    </>
  );
}

export default GiraffeProject;
